import React from "react";

const ProviderInput = ({
  label,
  required = false,
  type = "text",
  value,
  onChange,
  placeholder = "",
  options = [],
  rows = 4,
  error = "",
  className = "",
  inputClassName = "",
  ...props
}) => {
  const isTextarea = type === "textarea";
  const isSelect = type === "select";

  return (
    <div className={`provider-network-input-wrap ${className}`}>
      {label && (
        <label className="provider-network-label FP_Body">
          {label} {required && <span>*</span>}
        </label>
      )}

      {isTextarea ? (
        <textarea
          className={`provider-network-input FP_Content ${inputClassName} ${
            error ? "provider-network-input-error" : ""
          }`}
          value={value}
          placeholder={placeholder}
          rows={rows}
          onChange={(e) => onChange(e.target.value)}
          {...props}
        />
      ) : isSelect ? (
        <select
          className={`provider-network-input FP_Content ${inputClassName} ${
            error ? "provider-network-input-error" : ""
          }`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          {...props}
        >
          {options.map((option) => {
            const optionValue =
              typeof option === "string" ? option : option.value;

            const optionLabel =
              typeof option === "string" ? option : option.label;

            return (
              <option key={optionValue} value={optionValue}>
                {optionLabel}
              </option>
            );
          })}
        </select>
      ) : (
        <input
          className={`provider-network-input FP_Content ${inputClassName} ${
            error ? "provider-network-input-error" : ""
          }`}
          type={type}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          {...props}
        />
      )}

      {error && (
        <div className="provider-network-input-error-text FP_Help_Text">{error}</div>
      )}
    </div>
  );
};

export default ProviderInput;
